import ReviewList from '@/pages/review/ReviewList';
import ReviewDetail from '@/pages/review/ReviewDetail';
import ReviewAnalysis from '@/pages/review/ReviewAnalysis';
import EventReview from '@/pages/review/EventReview';
import CategoryReview from '@/pages/review/CategoryReview';
import ReviewWordStats from '@/pages/review/ReviewWordStats';
import Dictionary from '@/pages/review/Dictionary';
import Factor from '@/pages/review/Factor';
import ProductRank from '@/pages/review/ProductRank';
import ReviewReportList from '@/pages/review/ReviewReportList';
import ReviewReport from '@/pages/review/ReviewReport';
import ReviewBlind from '@/pages/review/ReviewBlind';
import ReviewAiInspection from '@/pages/review/ReviewAiInspection';

export default {
	ReviewList: {
		type: 'v3',
		id: 'ReviewList',
		title: '리뷰 목록 관리',
		heading: '리뷰 목록 관리',
		path: '/review/list',
		component: ReviewList,
	},
	ReviewAnalysis: {
		id: 'ReviewAnalysis',
		title: '리뷰 분석',
		heading: '리뷰 분석',
		path: '/review/review-analysis',
		component: ReviewAnalysis,
	},
	EventReview: {
		id: 'EventReview',
		title: '평가단 리뷰',
		heading: '평가단 리뷰',
		path: '/review/event-review',
		component: EventReview,
	},
	CategoryReview: {
		id: 'CategoryReview',
		title: '카테고리 리뷰',
		heading: '카테고리 리뷰',
		path: '/review/category-review',
		component: CategoryReview,
	},
	ReviewWordStats: {
		id: 'ReviewWordStats',
		title: '리뷰단어 통계',
		heading: '리뷰단어 통계',
		path: '/review/review-word-stats',
		component: ReviewWordStats,
	},
	Dictionary: {
		id: 'Dictionary',
		title: '사전',
		heading: '사전',
		path: '/review/dictionary',
		component: Dictionary,
	},
	Factor: {
		id: 'Factor',
		title: '성분',
		heading: '성분',
		path: '/review/factor',
		component: Factor,
	},
	ProductRank: {
		id: 'ProductRank',
		title: '제품랭킹',
		heading: '제품랭킹',
		path: '/review/product-rank',
		component: ProductRank,
	},
	ReviewDetail: {
		type: 'v3',
		id: 'ReviewDetail',
		title: '리뷰 조회/수정',
		heading: '리뷰 조회/수정',
		path: '/review/:idReview',
		component: ReviewDetail,
	},
	ReviewReportList: {
		type: 'v3',
		id: 'ReviewReportList',
		title: '리뷰 신고',
		heading: '리뷰 신고',
		path: '/review/report/list',
		component: ReviewReportList,
	},
	ReviewReport: {
		type: 'v3',
		id: 'ReviewReport',
		title: '리뷰 신고 상세정보',
		heading: '리뷰 신고 상세정보',
		path: '/review/report/:idReport',
		component: ReviewReport,
	},
	ReviewBlind: {
		id: 'ReviewBlind',
		title: '리뷰 블라인드',
		heading: '리뷰 블라인드',
		path: '/review/update/blind',
		component: ReviewBlind,
	},
	ReviewAiInspection: {
		id: 'ReviewAiInspection',
		title: '리뷰 AI 검수',
		heading: '리뷰 AI 검수',
		path: '/review/ai/inspection',
		component: ReviewAiInspection,
	},
};
